(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.register = function(module) {
    return module.service('Core.Services.Loading', ['$rootScope', '$compile', exports.Loading]);
  };

  exports.Loading = (function() {
    function Loading(rootScope, compile) {
      this.rootScope = rootScope;
      this.compile = compile;
      this._template = bind(this._template, this);
      this._load = bind(this._load, this);
      this.hideAll = bind(this.hideAll, this);
      this.overCustom = bind(this.overCustom, this);
      this.overAll = bind(this.overAll, this);
      this.overMapAndSidebar = bind(this.overMapAndSidebar, this);
      this.overSidebar = bind(this.overSidebar, this);
      this.overMap = bind(this.overMap, this);
      return;
    }

    Loading.prototype.overMap = function(msg) {
      if (msg == null) {
        msg = 'Loading...';
      }
      return this._load(this._template(msg), '#master_content', ['loader-over-map']);
    };

    Loading.prototype.overSidebar = function(msg) {
      if (msg == null) {
        msg = 'Loading...';
      }
      return this._load(this._template(msg), '.map_sidebar:visible', ['loader-over-sidebar']);
    };

    Loading.prototype.overMapAndSidebar = function(msg) {
      if (msg == null) {
        msg = 'Loading...';
      }
      return this._load(this._template(msg), '#map_container', ['loader-over-map', 'loader-over-sidebar']);
    };

    Loading.prototype.overAll = function(msg) {
      if (msg == null) {
        msg = 'Loading...';
      }
      return this._load(this._template(msg), 'body', ['loader-over-all']);
    };

    Loading.prototype.overCustom = function(selector, msg, modifier, classes) {
      if (msg == null) {
        msg = 'Loading...';
      }
      if (modifier == null) {
        modifier = null;
      }
      if (classes == null) {
        classes = ['loader-over-absolute'];
      }
      if (modifier) {
        return this._load(this._template(msg, "preloader-container " + modifier), selector, classes);
      }
      return this._load(this._template(msg), selector, classes);
    };

    Loading.prototype.hideAll = function() {
      return angular.element('.loader-wrap').remove();
    };

    Loading.prototype._load = function(template, wrapper, addclasses) {
      var cls, compiled, elem, i, len;
      if (addclasses == null) {
        addclasses = [];
      }
      elem = angular.element(template);
      if (!$.isArray(addclasses)) {
        addclasses = [addclasses];
      }
      for (i = 0, len = addclasses.length; i < len; i++) {
        cls = addclasses[i];
        elem.addClass(cls);
      }
      elem = angular.element("<div class='bs2'>").append(elem);
      compiled = this.compile(elem);
      angular.element(wrapper).append(elem);
      compiled(this.rootScope);
      return {
        hide: function() {
          return elem.remove();
        }
      };
    };

    Loading.prototype._template = function(msg, container_class) {
      if (container_class == null) {
        container_class = 'preloader-container';
      }
      return "<div class='loader-wrap'>\n    <div class='" + container_class + "'>\n        <div class='preloader-message'>\n            <div class='preloader-spinner' us-spinner='{radius:18, length: 18, width:4, color: \"#FFFFFF\"}'>\n            </div>\n            <div class='preloader-text'>" + msg + "</div>\n        </div>\n    </div>\n</div>";
    };

    return Loading;

  })();

}).call(this);
